import { extendTheme as r } from "@chakra-ui/react";
const F = {
  container: 6,
  input: "0.375rem",
  button: "0.375rem"
}, g = {
  container: {
    px: {
      base: 0,
      md: 12
    },
    py: {
      base: 4,
      md: 12
    }
  },
  button: {
    px: {
      base: 4,
      md: 6
    },
    py: {
      base: 4,
      md: 6
    }
  }
}, t = {
  base: "260px",
  md: "260px"
}, o = {
  base: "34px",
  md: "34px"
}, a = {
  base: 70
}, n = {
  input: "0.85rem",
  label: "0.8rem",
  title: {
    base: "1.25rem",
    md: "1.5rem"
  }
}, s = {
  label: 500
}, i = {
  base: "1rem"
}, p = {
  inputWidth: t,
  inputHeight: o,
  fontSize: n,
  fontWeight: s,
  inputPadding: i,
  inputContainerHeight: a,
  labelPadding: {
    base: "0 12px 4px 0"
  }
}, u = {
  fontSize: {
    badge: { base: "0.75rem", lg: "0.875rem" },
    tag: { base: "0.75rem", lg: "0.875rem" },
    text: { base: "0.875rem", lg: "1rem" },
    button: { base: "0.875rem", lg: "1rem" },
    icon: { base: "1rem", lg: "1.25rem" }
  },
  size: {
    badge: "sm",
    tag: "sm",
    button: "sm",
    spinner: "xs"
  },
  fontWeight: {
    normal: 500,
    bold: 700
  },
  gap: {
    small: "0.5rem",
    medium: "1rem"
  },
  padding: {
    button: "0.5rem",
    buttonWithText: "0.5rem 1rem",
    iconOnlyButton: "0.5rem"
  }
}, d = {
  initialColorMode: "light",
  useSystemColorMode: !1
}, e = {
  white: "#FFF",
  black: "#000000",
  primary: {
    1: "#28574A",
    2: "#75C3AE",
    3: "#A3D7C9",
    4: "#D1EBE4"
  },
  secondary: {
    1: "#304376",
    2: "#7582A4",
    3: "#BAC0D1"
  },
  tertiary: {
    1: "#7A86FF",
    2: "#A6AEFF",
    3: "#D3D7FF"
  },
  apply: {
    0: "#E3F2FD",
    1: "#90CAF9",
    2: "#2196F3"
  },
  neutro: {
    1: "#FBFAF9",
    2: "#F7F4F2",
    3: "#F3EFEC"
  },
  text: {
    1: "#1B1C1E",
    2: "#303030",
    3: "#707070",
    4: "#C5C6CC",
    5: "#F8F9FE"
  },
  error: {
    1: "#ED3241",
    2: "#FF616D"
  },
  orange: {
    1: "#FF8845"
  },
  gray88: "#E0E0E0",
  primaryLight: "#67BFAC",
  primaryDark: "#1F2024",
  neutralLight: "#D4D6DD",
  neutralDark: "#71727A",
  lightQuaternary: "#F4F4F5",
  neutralLightDarkest: "#C5C6CC",
  complementary1: "#FEE576",
  border: "#d7d8db",
  whatsapp: {
    light: "#25D366",
    dark: "#075E54"
  },
  brand: {
    50: "#D1EBE4",
    100: "#A3D7C9",
    200: "#75C3AE",
    300: "#67BFAC",
    400: "#5BB59F",
    500: "#75C3AE",
    600: "#28574A",
    700: "#1F4A3E",
    800: "#163D32",
    900: "#0D3026"
  },
  blue: {
    50: "#E3F2FD",
    200: "#90CAF9",
    500: "#2196F3"
  },
  gray: {
    50: "#FAFAFA",
    200: "#EEEEEE",
    600: "#757575"
  },
  green: {
    500: "#4CAF50"
  },
  red: {
    500: "#F44336"
  }
}, c = {
  default: {
    focus: {
      border: e.tertiary[1]
    },
    hover: {
      backgroundColor: e.tertiary[2]
    }
  },
  error: {
    border: e.error[1]
  },
  disabled: {},
  readOnly: {}
}, C = e.tertiary[1], E = {
  bg: "rgba(211, 215, 255, 0.3)",
  border: "1px solid",
  borderColor: "rgba(166, 174, 255, 0.5)"
}, m = {
  heading: "Inter Variable, Inter, system-ui, sans-serif",
  body: "Inter Variable, Inter, system-ui, sans-serif"
}, l = {
  Button: {
    baseStyle: {
      fontWeight: "semibold",
      borderRadius: "md"
    },
    defaultProps: {
      colorScheme: "gray"
    }
  },
  Input: {
    defaultProps: {
      borderRadius: "md"
    }
  },
  Card: {
    baseStyle: {
      container: {
        borderRadius: "lg",
        boxShadow: "md"
      }
    }
  }
}, y = r({
  config: d,
  colors: e,
  fonts: m,
  components: l
});
export {
  e as colors,
  p as field,
  n as fontSize,
  s as fontWeight,
  c as formColors,
  a as inputContainerHeight,
  o as inputHeight,
  i as inputPadding,
  t as inputWidth,
  g as padding,
  C as requiredAsteriskColor,
  F as rounded,
  E as specialBoxStyles,
  u as tableStyles,
  y as zummaTheme
};
